import { SvgIcon, SvgIconProps } from "@mui/material";

export const AllServicesBackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M19 12H5M5 12L11 6M5 12L11 18" stroke="#111111" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const AllServicesPreviousButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M16.3334 9.99996H4.66669M4.66669 9.99996L10.5 15.8333M4.66669 9.99996L10.5 4.16663"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AllServicesNextButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "21", height: "20", fill: "none" }}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M4.66663 9.99996H16.3333M16.3333 9.99996L10.5 4.16663M16.3333 9.99996L10.5 15.8333"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
